import Vue from 'vue'
import facebookLogin from './index';

Vue.component(facebookLogin.name, facebookLogin)
